import React from "react";

/**
 * Format NullTime object (from Go backend) to readable date string
 * @param {Object} val - { Valid: boolean, Time: string }
 * @returns {string} Formatted date or "-"
 */
export const formatDate = (val) => {
  if (val && val.Valid) {
    const date = new Date(val.Time);
    return date.toLocaleDateString("en-GB", {
      day: "2-digit",
      month: "short",
      year: "numeric",
    });
  }
  return "-";
};

/**
 * Format date string with time (for activity logs and detail modals)
 * @param {string} dateStr - ISO date string
 * @returns {string} Formatted date with time or "-"
 */
export const formatDateStr = (dateStr) => {
  if (!dateStr) return "-";
  const date = new Date(dateStr);
  return date.toLocaleString("en-GB", {
    day: "2-digit",
    month: "short",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
  });
};

/**
 * Format credit/number with proper decimal places
 * @param {number} value - Number to format
 * @returns {string} Formatted number
 */
export const formatCredit = (value) => {
  if (typeof value !== "number") return "0.00";
  return value.toLocaleString("en-US", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 4,
  });
};

/**
 * Format number with flexible decimal places
 * @param {number} num - Number to format
 * @returns {string} Formatted number or "-"
 */
export const formatNumber = (num) => {
  if (num === undefined || num === null) return "-";
  return Number(num).toLocaleString("en-US", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 6,
  });
};

/**
 * Render credit symbol component for SMS
 * @returns {JSX.Element} Credit symbol span
 */
export const CreditSymbol = () => (
  <span className="credit-symbol">C</span>
);

/**
 * Get currency display based on product type
 * @param {number} value - Credit value
 * @param {string} type - Product type (sms, viber, whatsapp)
 * @returns {JSX.Element} Formatted currency display
 */
export const getCurrencyDisplay = (value, type) => {
  const formatted = formatCredit(value);
  if (type === "sms") {
    return (
      <span>
        <CreditSymbol />
        {formatted}
      </span>
    );
  }
  return <span>${formatted}</span>;
};

/**
 * Safely parse JSON string
 * @param {string} str - JSON string
 * @returns {Object|null} Parsed object or null
 */
export const parseJSON = (str) => {
  try {
    return JSON.parse(str);
  } catch (e) {
    return null;
  }
};

/**
 * Get country flag emoji
 * @param {string} countryCode - Country code (TH, MY, PH, etc.)
 * @returns {string} Flag emoji
 */
export const getCountryFlag = (countryCode) => {
  const flags = {
    TH: "🇹🇭",
    MY: "🇲🇾",
    PH: "🇵🇭",
    SG: "🇸🇬",
    ID: "🇮🇩",
    VN: "🇻🇳",
    GLOBAL: "🌐",
  };
  return flags[countryCode] || "🌍";
};



// WEBPACK FOOTER //
// ./src/containers/User/UserManagement/components/MemberCreditWallet/utils/formatters.js